/* eslint-disable react/no-array-index-key */
import { Suspense } from 'react';
import { AnimatePresence } from 'framer-motion';
import { Routes, Route, Navigate } from 'react-router-dom';

import MainLayout from '@lok/pages/layout';
import PublicRoute from './PublicRoute';
import ProtectedRoute from './ProtectedRoute';
import SuperAdminRoute from './SuperAdminRoute';
import GlobalLoader from '../components/Layouts/Loading';
import { protectedRoutes, publicRoutes, openRoutes, superAdminRoutes } from './constants';

const AppRoute = ({
  component: Component,
  routeKey,
  ...props
}) => {
  return <Component {...props} />;
};

const AllRoutesDefinitions = () => {
  return (
    <Routes>
      {/* Open routes: reachable regardless of auth state (e.g. one-click unsubscribe
          landing pages from email). Declared first so they win over the catch-all `*`
          inside ProtectedRoute. */}
      {openRoutes.map((route) => (
        <Route
          key={route.key}
          path={route.path}
          element={
            <AppRoute
              routeKey={route.key}
              component={route.component}
            />
          }
        />
      ))}
      <Route path='/' element={<ProtectedRoute />}>
        <Route
          path='/'
          element={<Navigate replace to='/dashboard' />}
        />
        {protectedRoutes.map((route, index) => (
          <Route
            key={route.key + index}
            path={route.path}
            element={
              <MainLayout hasRightSidebar={route.hasRightSidebar || false}>
                <AppRoute
                  routeKey={route.key}
                  component={route.component}
                />
              </MainLayout>
            }
          />
        ))}
        <Route element={<SuperAdminRoute />}>
          {superAdminRoutes.map((route, index) => (
            <Route
              key={route.key + index}
              path={route.path}
              element={
                <MainLayout hasRightSidebar={false}>
                  <AppRoute
                    routeKey={route.key}
                    component={route.component}
                  />
                </MainLayout>
              }
            />
          ))}
        </Route>
        <Route
          path='*'
          element={<Navigate replace to='/' />}
        />
      </Route>
      <Route path='/' element={<PublicRoute />}>
        {publicRoutes.map((route) => (
          <Route
            key={route.path}
            path={route.path}
            element={
              <AppRoute
                routeKey={route.key}
                component={route.component}
              />
            }
          />
        ))}
      </Route>
    </Routes>
  );
};

const AllRoutes = (props) => {
  return (
    <Suspense fallback={<GlobalLoader />}>
      <AnimatePresence>
        <AllRoutesDefinitions {...props} />
      </AnimatePresence>
    </Suspense>
  );
};

export default AllRoutes;
